<template>
  <div class="page page-404">
    <section class="section">
      <div class="container">
        <h1 class="text-center">404 - Not Found</h1>
      </div>
    </section>
  </div>
</template>
